import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/announcements.json';
import ar from './i18n/ar/announcements.json';

registerFeatureI18n('adminAnnouncements', { en, ar });

export { AnnouncementsPage } from './AnnouncementsPage';
